module.exports = __webpack_public_path__ + "img/EXV_Weinflaschen_Icons_Portweine.46993cee.svg";